define('drops/businessProcessCanvas/businessProcessCanvas',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/dropFactory',
    'drops/drawings/businessprocessEvents',
    'drops/drawings/runtimeTypesProvider',
    'lq/onlongpress',
    'html2canvas',
    'when'
],
function (
    $,
    Drop,
    Style,
    util,
    DropFactory,
    businessProcessEvents,
    runtimeTypesProvider,
    OnLongPress,
    html2canvas,
    when) {
    'use strict';

    var defaults = {
        data: {
            text: 'Guid',
            longPressDelay: 1000
        }
    };

    function BusinessProcessCanvas(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        var self = this;

        self.rootDrop = this;
        self.drawingDropFactory = new DropFactory(runtimeTypesProvider, false);

        self.data.eventing = util.convertListOfKeyValuesToObject(self.data.eventing);

        self.$canvas = $('<div/>')
            .addClass('boxToBorderSize')
            .attr('name', self.data.name)
            .appendTo(self.$element)
            .attr('tabindex', self.data.tabIndex)
            .css({
                overflow: "scroll",
                position: "relative",
                display: "block",
                verticalAlign: 'middle',
                width: '100%',
                height: '100%'
            });

        self.$element
            .css({
                whiteSpace: 'pre-wrap',
                display: "block"
            });

        if (!this.designData && this.isEventEnabled('onLongPress')) {
            OnLongPress.applyLongPressOnElement(this.$canvas, this);
        }

        Style.renderStyles(self,null, self.$canvas);

        return self;
    };

    Drop.extend(BusinessProcessCanvas, Drop);

    BusinessProcessCanvas.typeName = 'BusinessProcessCanvas';

    BusinessProcessCanvas.prototype.setValue = function (update) {
        var self = this;
        self.piping.dispatcher.dispatch(
            'LicquidAction/GetDrawing',
            {
                id: update.value
            },
            function (result) {
                self.$canvas.empty();

                var drops = self.drawingDropFactory.createDrops(result.drawing.childDrops);

                _.each(drops, function (drop) {
                    drop.piping = self.piping;
                    drop.render(self.$canvas);
                });

                _.each(drops, function (drop) {
                    businessProcessEvents.informListeners('bp_element_moved_' + drop.data.id, drop);
                });

                setTimeout(function () {
                    html2canvas(self.$canvas.get(0)).then(function (canvas) {
                        //document.body.appendChild(canvas);
                        var imageData = canvas.toDataURL('image/png');

                        var img = $('<img />', { src: imageData });
                        img.appendTo('body');
                    });
                }, 2000)

            }
        );
    };

    BusinessProcessCanvas.prototype.renderStyles = function () {
        Style.renderStyles(this, null, this.$canvas);
    };

    BusinessProcessCanvas.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    BusinessProcessCanvas.prototype.getFile = function () {
        var deferred = when.defer();

        html2canvas(this.$canvas).then(function (canvas) {
            var image = canvas.toDataURL(imageType);
            deferred.resolve(image);
        });

        return deferred.promise;
    };

    return BusinessProcessCanvas;
});
